import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-burger-menu",
  "use": "icon-burger-menu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-burger-menu\">\n    <path d=\"M3 5.25V6.75H21V5.25H3ZM3 11.25V12.75H21V11.25H3ZM3 17.25V18.75H21V17.25H3Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol